__turbopack_context__.v({
  "chart": "UspsFairPrice-module-scss-module__QiOpWq__chart",
  "chart-wrapper": "UspsFairPrice-module-scss-module__QiOpWq__chart-wrapper",
  "comparison": "UspsFairPrice-module-scss-module__QiOpWq__comparison",
  "comparison-charts": "UspsFairPrice-module-scss-module__QiOpWq__comparison-charts",
  "comparison-description": "UspsFairPrice-module-scss-module__QiOpWq__comparison-description",
  "comparison-title": "UspsFairPrice-module-scss-module__QiOpWq__comparison-title",
  "indicator": "UspsFairPrice-module-scss-module__QiOpWq__indicator",
  "invoice-description": "UspsFairPrice-module-scss-module__QiOpWq__invoice-description",
  "legend": "UspsFairPrice-module-scss-module__QiOpWq__legend",
});
